import { Component, inject, input, InputSignal } from '@angular/core';
import { FormGroup, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MovilityType } from '../../../interfaces/register-user.response';
import { normalizeValue } from '../../../utils/value-normalizer';
import { RegisterUserFormService } from '../../../services/register-user-form.service';
import { BaseFormField } from '../../form/abstracts';
import { RegisterUserService } from '../../../services';
import { RAW_MOVILITY_TYPES } from './config/constants';

@Component({
  selector: 'app-movility-field',
  standalone: true,
  imports: [
    TranslateModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: MovilityFieldComponent
    },
  ],
  templateUrl: './movility-field.component.html',
  styleUrls: ['./movility-field.component.scss'],
})
export class MovilityFieldComponent extends BaseFormField<string> {
  public form: InputSignal<FormGroup> = input.required<FormGroup>();
  public formControlName: InputSignal<string> = input.required<string>();
    
  private _translateService = inject(TranslateService);
  private _registerUserService = inject(RegisterUserService);
  private _registerUserFormService = inject(RegisterUserFormService);
  
  protected cityLocation = this._registerUserService.cityLocation;

  public movilityTypes: MovilityType[] = RAW_MOVILITY_TYPES
    .map((type) => {
      const translated = this._translateService.instant(type);
      return {
        value: normalizeValue(translated),
        name: translated,
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name));
  
    
  public handleMovilityTypeChange(event: MatSelectChange) {
    const selectedMovility = event.value;
    this._registerUserFormService.setMovilityType(selectedMovility);
  }
}
